<template>
  <div>
    <h1>Audio Transcoder</h1>
    <input type="file" id="fileInput"  @change="onFileChange">
    <button @click="convertToMP3">Convert to MP3</button>
    <div id="progressBar">
      <div class="bar" :style="{ width: progressBarWidth }"></div>
    </div>
    <audio id="audioPlayer" controls v-if="audioUrl" :src="audioUrl"></audio>
    <div id="errorMessage" v-if="errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';

export default {
  data() {
    return {
      ffmpeg: null,
      file: null,
      progressBarWidth: '0%',
      audioUrl: null,
      errorMessage: 'no error',
    };
  },
  methods: {
    async initFFmpeg() {
      if (!this.ffmpeg) {
        this.ffmpeg = createFFmpeg({ log: true });
        try {
          await this.ffmpeg.load();
        } catch (error) {
          console.error('Error loading ffmpeg:', error);
          this.showError('Error loading ffmpeg. Please try again or use a different browser.');
        }
      }
    },
    onFileChange(event) {
      this.file = event.target.files[0];
    },
    async convertToMP3() {
      if (!this.file) {
        alert('Please select a file first.');
        return;
      }

      try {
        await this.initFFmpeg();

        const arrayBuffer = await fetchFile(this.file);
        console.log('File read successfully:', arrayBuffer);
        this.showError('File read successfully');
        const fileName = this.file.name;
        console.log('Writing file to virtual filesystem:', fileName);
        this.showError('Writing file to virtual filesystem');
        this.ffmpeg.FS('writeFile', fileName, new Uint8Array(arrayBuffer));

        console.log('Running ffmpeg command');
        this.showError('Running ffmpeg command');
        // 设置进度条
        this.ffmpeg.setProgress(({ ratio }) => {
          const percent = Math.round(ratio * 100);
          this.progressBarWidth = `${percent}%`;
          console.log(`Conversion progress: ${percent}%`);
          this.showError(`Conversion progress: ${percent}%`);
        });

        await this.ffmpeg.run('-i', fileName, '-vn', '-ar', '16000', '-ac', '1', '-ab', '16k', '-f', 'mp3', 'output.mp3');

        console.log('Reading output file');
        this.showError('Reading output file');
        const data = this.ffmpeg.FS('readFile', 'output.mp3');
        this.audioUrl = URL.createObjectURL(new Blob([data.buffer], { type: 'audio/mp3' }));
        console.log('Generated audio URL:', this.audioUrl);
        this.showError(`Generated audio URL:${this.audioUrl}`);
      } catch (error) {
        console.error('Error during conversion:', error);
        this.showError('An error occurred during conversion. Please check the console for more details.');
      }
    },
    showError(message) {
      this.errorMessage = message;
      this.$nextTick(() => {
        console.log('Error message updated:', this.errorMessage);
      });
    },
  },
};
</script>

<style scoped>
#progressBar {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px solid #ccc;
  margin-top: 10px;
  height: 30px;
}
#progressBar .bar {
  height: 100%;
  background-color: #4caf50;
  width: 0;
}
#errorMessage {
  color: red;
  margin-top: 10px;
  display: none;
}
</style>